
































import type { Ref } from '@nuxtjs/composition-api';
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  useContext,
  useRoute
} from '@nuxtjs/composition-api';

import type { MenuItemModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'AppFooter',
  components: {
    VaimoOrnement: () => import('atoms/VaimoOrnement.vue'),
    VaimoEcomBenefits: () => import('organisms/VaimoEcomBenefits.vue'),
    VaimoFooterPleatPanels: () =>
      import('organisms/footer/PleatsPanel/VaimoFooterPleatPanels.vue'),
    VaimoHelpBlock: () => import('organisms/VaimoHelpBlock.vue'),
    VaimoNewsletterSubscription: () =>
      import('organisms/VaimoNewsletterSubscription.vue'),
    VaimoStoreSwitcher: () =>
      import('organisms/VaimoStoreSwitcher/VaimoStoreSwitcher.vue')
  },
  setup() {
    const route = useRoute();
    const routePath = computed(() => route.value.path);
    const isVisible = ref(false);
    const socialLinks: Ref<MenuItemModel[]> = ref([]);
    const { i18n } = useContext();
    const locale = i18n.localeProperties?.code;

    const isCheckout = computed(() => {
      return routePath.value.includes('checkout');
    });

    const is404page = computed(() => {
      return route.value.matched.length === 0;
    });

    const isThankYouPage = computed(() => {
      return routePath.value.includes('checkout/thank-you');
    });

    onMounted(() => {
      nextTick(() => {
        isVisible.value = true;
      });
    });

    const handleSocialLinksLoading = (links: MenuItemModel[]) => {
      socialLinks.value = links;
    };

    return {
      isVisible,
      isCheckout,
      isThankYouPage,
      is404page,
      locale,
      socialLinks,
      handleSocialLinksLoading
    };
  }
});
